import React, {  Component } from 'react';

export default class SelectedProductLinesDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			productLinesList: [],
        };
		this.updateSelectedProductLines = this.updateSelectedProductLines.bind(this);
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog("SelectedProductLinesDialog", false);
    }
	updateSelectedProductLines(event) {
		const self = this;
		let { productLinesList } = self.state;
		productLinesList.forEach(itm => {
			if(itm.name === event.target.name) {
				itm.checked = event.target.checked;
			}
		});
		self.setState({
			productLinesList
		});
	}
	componentWillMount() {
		this.setState({
			productLinesList: JSON.parse(JSON.stringify(this.props.productLinesList)),
		})
	}
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    render() {
        return (
			<div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")}>
                <div className="blackoutLayer"></div>
				<div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Include the Selected Product Lines</h2>
					<div className="check">
						{this.state.productLinesList.map((item, index) => {
							return <span key={ index }>
								<input type="checkbox" value={item.value} onChange={(event) => this.updateSelectedProductLines(event)} name={item.name} id={item.name} checked={item.checked} />
								<label htmlFor={item.name}>{item.name}</label><br /><br />
							</span>
						})}
			      	</div>
					<div className="noButtonContainer">
						<a className="noButton blueButton" href="" onClick={(event) => this.props.handleUpdatedProductLines(false, this.state.productLinesList, event)}>Cancel</a>
					</div>
					<div className="yesButtonContainer">
						<a className="yesButton blueButton" href="" onClick={(event) => this.props.handleUpdatedProductLines(true, this.state.productLinesList, event)}>Use Selected Products</a>
					</div>
             	</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/selectedProductLinesDialog.js